module.exports = __webpack_public_path__ + "img/uimg2.a0fae803.jpg";